module.exports = __webpack_public_path__ + "img/img95.c0216aa4.svg";